import { useEffect, useMemo, useRef } from 'react'

import _throttle from 'lodash-es/throttle'

export function useThrottle(
  cb: (e?: any) => void,
  delay: number,
  options?: { leading?: boolean; trailing?: boolean },
) {
  const cbRef = useRef(cb)

  useEffect(() => {
    cbRef.current = cb
  })

  return useMemo(
    () => _throttle((e?: any) => cbRef.current(e), delay, options),
    [delay, options],
  )
}
